import React from "react";
import { Star, Quote, ExternalLink } from "lucide-react";
import { reviews, googleReviewsUrl } from "../mock";

const Reviews = () => {
  return (
    <section className="py-20 bg-neutral-900 text-white">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between mb-12 gap-6">
          <div>
            <p className="text-sm tracking-[0.3em] uppercase text-neutral-400 mb-3">
              — Bekijk onze recensies
            </p>
            <h2 className="text-4xl md:text-5xl font-bold leading-tight">
              Wat onze klanten
              <br />
              <span className="italic font-light text-neutral-300">over ons zeggen.</span>
            </h2>
          </div>
          <a
            href={googleReviewsUrl}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-4 bg-white/5 border border-white/10 px-5 py-3 hover:bg-white/10 transition-colors group"
          >
            <div className="w-11 h-11 rounded-full bg-white flex items-center justify-center font-bold text-neutral-900">
              G
            </div>
            <div>
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={13} className="fill-amber-400 text-amber-400" />
                ))}
                <span className="ml-1.5 font-bold">4.9</span>
              </div>
              <p className="text-xs text-neutral-400 group-hover:text-white transition-colors">
                Bekijk reviews op Google
              </p>
            </div>
            <ExternalLink size={14} className="text-neutral-400 group-hover:text-white transition-colors" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, idx) => (
            <div
              key={idx}
              className={`relative bg-white/5 border p-7 hover:bg-white/10 transition-colors ${review.badge ? "border-amber-400/40 ring-1 ring-amber-400/20" : "border-white/10"}`}
            >
              <Quote size={36} className="text-white/10 absolute top-5 right-5" />
              {review.badge && (
                <div className="inline-flex items-center gap-1.5 bg-amber-400/20 border border-amber-400/40 text-amber-200 px-2 py-0.5 text-[10px] font-semibold tracking-widest uppercase mb-3">
                  ⭐ {review.badge}
                </div>
              )}
              <div className="flex items-center gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} size={14} className="fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="text-neutral-200 leading-relaxed mb-6 text-[15px] relative z-10">
                &ldquo;{review.text}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center font-semibold text-sm">
                  {review.name.charAt(0)}
                </div>
                <div>
                  <p className="font-medium text-white text-sm">{review.name}</p>
                  <p className="text-xs text-neutral-400">{review.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href={googleReviewsUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 bg-white text-neutral-900 hover:bg-neutral-100 px-7 py-4 text-[15px] font-medium tracking-wide transition-colors"
          >
            Bekijk alle reviews op Google
            <ExternalLink size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
